import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AffecteCycleELComponent } from './affecte-cycleel.component';
import { PipeModule } from '../pipes';
import { DateModule } from '../date';
import { BoPropertyInlineModule } from '../bodisplay/dynamictags-inline/bo-property-inline';
import { WalletModule } from '../wallet';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    PipeModule,
    DateModule,
    BoPropertyInlineModule,
    WalletModule
  ],
  declarations: [
    AffecteCycleELComponent
  ],
  exports: [
    AffecteCycleELComponent
  ]
})

export class AffecteCycleELModule { }
